module.exports = __webpack_public_path__ + "img/miller-high-life-logo.77a510e2.png";